import styled from 'styled-components';

import { useCallback } from 'react';
import {
  useRfqBuilderActions,
  useRfqBuilderLegView,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import { blueMana, razzmatazz } from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function RemoveLegButton() {
  const { index } = useRfqBuilderLegView();
  const { removeLeg } = useRfqBuilderActions();
  const { strategy, strategyShortcut } = useRfqBuilderView();
  const trackAction = useTrackAction();

  const strategyCode =
    strategyShortcut.selectedOption?.value ??
    strategy.selectedOption?.value ??
    null;
  const label = <Label>Remove Leg</Label>;
  const icon = <Icon />;

  const handleClick = useCallback(() => {
    trackAction('remove strategy leg', { strategyCode });
    removeLeg(index);
  }, [index, removeLeg, strategyCode, trackAction]);

  return (
    <Button onClick={handleClick}>
      {icon} {label}
    </Button>
  );
}

const Label = styled.span`
  display: none;
  color: ${blueMana};
  font-size: 1rem;
  line-height: 1.25rem;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: inline;
  }
`;

const Icon = styled.i.attrs({
  className: 'material-icons',
  children: 'clear',
})`
  font-size: 0.75rem;
  color: ${razzmatazz};

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    display: none;
  }
`;

const Button = styled.button`
  background: transparent;
  border: none;
  width: 12px;
  padding: 0px;
  display: flex;
  padding-left: 5px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    width: auto;
    flex-grow: 1;
    justify-content: flex-end;
  }
`;
